import { AnalyticsKey } from "src/Tenants";
import ReactGA from "react-ga4";
import type { ISignInResponse } from "./types";
import { Dispatch } from "redux";
import { TYPES } from "src/common/constants";
import { setPermissions } from "src/store/actions/auth";


export const handleSignIn = (response: ISignInResponse, dispatch: Dispatch<any>, history: any) => {
  if (!response || !response.user) {
    throw new Error('Invalid sign-in response');
  }

  localStorage.setItem('userId', response.user.id);
  localStorage.setItem('checked', 'checked');

  if (AnalyticsKey) {
    ReactGA.initialize(AnalyticsKey);
    ReactGA.set({ userId: response.user.firstname + ' ' + response.user.lastname });
  }

  setPermissions(response.user, history, response.user, dispatch);

  dispatch({
    type: TYPES.AUTH_SIGN_IN_DONE,
    payload: response,
  });
}
